import { render } from "./ChartPage.vue?vue&type=template&id=a5be8736&ts=true"
import script from "./ChartPage.vue?vue&type=script&lang=ts"
export * from "./ChartPage.vue?vue&type=script&lang=ts"

import "./ChartPage.vue?vue&type=style&index=0&id=a5be8736&lang=scss"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/Zalo/CheckDB130_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__